import React from 'react';
import { graphql } from 'gatsby';
import { OmDividendCardGroup } from '@om/component-library-react';



const DividendCardGroup = ({
    OmDividendCardGroupContent
}) => {
    if (!OmDividendCardGroupContent) {
        return '';
    }
    const { dividend_cards,
        heading,
        subheading
    } = OmDividendCardGroupContent;

    
    const sortedDividendCards = JSON.stringify([...dividend_cards].sort((a, b) => {return a.sort_order - b.sort_order}));
    


    return (
        <OmDividendCardGroup data={sortedDividendCards}>
             {
                heading ?
                    (
                        <h4 slot="heading" dangerouslySetInnerHTML={{__html: heading}} />
                    )
                    : ''
            }
              {
                subheading ?
                    (
                        <h6 slot="sub-title" dangerouslySetInnerHTML={{__html: subheading}} />
                    )
                    : ''
            }    
             
        </OmDividendCardGroup>
    );
};

export const pageQuery = graphql`
fragment DividendCardGroup on Contentstack_dividend_card_group {
    title
    heading
    subheading
    dividend_cards {
        ...DividendCard
        }
    }
    fragment DividendCard on Contentstack_dividend_card {
    title
    id
    currency_prefix
    currency_suffix
    share_price
    sort_order
    flag {
    url
    }
    }    
`;

export default DividendCardGroup;
